import { ApiService } from "../../../constants/ApiService";
import { HttpService } from "../../../constants/HTTPService";
import { NewIDataUploadItem } from "../../../interfaces/IDataUploadItem";
import { IForm } from "../../../interfaces/IForm";

export const getUserTesting = async () => {
  const data = HttpService.get(ApiService.testing.getTestingUser);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListRequestType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListRequestType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListDocumentType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListDocumentType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListAreaLocation = async () => {
  const data = HttpService.post(
    ApiService.apiHc.getAreaLocation,
    JSON.stringify({
      AreaLocation: { LocationID: "", LocationHierarcyID: "" },
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const sendHardCopySKByCL = async (
  dataForm?: IForm,
  binusianID?: string,
  dataUploadSK?: NewIDataUploadItem[],
  uploadRealization?: NewIDataUploadItem[],
  dataUpload?: NewIDataUploadItem[],
  requestID?: string,
  requestStatusID?: string,
  crrNumber?: string,
  actionButtonClick?: string,
  emailType?: string
) => {
  function convertData(inputData: NewIDataUploadItem[]) {
    return inputData.reduce((acc: any[], curr) => {
      const files = curr.files.map((file) => ({
        title: curr.title,
        fileType: curr.fileType,
        ...file,
      }));
      return [...acc, ...files];
    }, []);
  }
  const files = convertData(dataUpload || []);
  const realization = convertData(uploadRealization || []);
  const sk = convertData(dataUploadSK || []);

  const data = HttpService.post(
    ApiService.alesaForm.EditFormCorporateLegalHardCopySK,
    JSON.stringify({
      CrrNumber: crrNumber,
      BinusianID: binusianID,
      ListDocument: files,
      RequestID: requestID,
      RequestStatusID: requestStatusID,
      StartDateString: dataForm?.startDatePeriod,
      EndDateString: dataForm?.endDatePeriod,
      ActionClick: actionButtonClick,
      ListFileUploadDocumentHardCopySK: sk,
      ListFileUploadDocumentRealization: realization,
      EmailType: emailType,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const getSingleDataRequest = async (requestID?: string) => {
  const data = HttpService.post(
    ApiService.alesaForm.getSingleDataRequest,
    JSON.stringify({
      RequestID: requestID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadSingleFile = async (
  documentName?: string,
  category?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadSingleFile,
    JSON.stringify({
      DocumentName: documentName,
      Category: category,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getSharepointToken = async () => {
  const data = HttpService.get(ApiService.alesaForm.getSharepointToken);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const sendBack = async (
  requestID?: string,
  binusianID?: string,
  comment?: string,
  commentDocument?: NewIDataUploadItem[],
  requestStatusID?: string,
  crrNumber?: string
) => {
  function convertData(inputData: NewIDataUploadItem[]) {
    return inputData.reduce((acc: any[], curr) => {
      const files = curr.files.map((file) => ({
        title: curr.title,
        fileType: curr.fileType,
        ...file,
      }));
      return [...acc, ...files];
    }, []);
  }
  const files = convertData(commentDocument || []);
  const data = HttpService.post(
    ApiService.alesaForm.sendBackFromLegalRelationship,
    JSON.stringify({
      CrrNumber: crrNumber,
      RequestID: requestID,
      BinusianID: binusianID,
      Comment: comment,
      ListCommentDocument: files,
      RequestStatusID: requestStatusID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const downloadFileComment = async (
  commentID?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadFileComment,
    JSON.stringify({
      CommentID: commentID,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const resendEmailFinishedForm = async (
  requestID?: string,
  emailType?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.resendEmailFinishedForm,
    JSON.stringify({
      RequestID: requestID,
      EmailType: emailType,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};
